import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { BandageCheckAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-bandage-check-slot',
    templateUrl: './bandage-check-slot.component.html',
    styleUrl: './bandage-check-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BandageCheckSlotComponent implements SheetSlotComponentBase {

	@Input() action!: BandageCheckAction;
	value = null;

	constructor() {
	}
}